import React from 'react';
import Dropzone from 'react-dropzone';
import Modal from '../../../commonComponents/util/Modal';
import Select from '../../../commonComponents/util/Select';
import LoadingSpinner from '../../../commonComponents/util/LoadingSpinner';
import ValidatedInput from '../../../commonComponents/util/ValidatedInput';
import FadeErrorMessage from '../../../commonComponents/util/FadeOutErrorMessage';

export default class SignatureModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            signature: {
                fundId: '',
                file: null
            },
            error: false,
            submitAttempted: false,
            rejectedFile: false
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.fundId !== this.props.fundId) {
            this.setState({signature: {file: null, fundId: nextProps.fundId || ''}})
        }
    }

    onChange(name, value) {
        this.setState({ signature: { ...this.state.signature, ...{ [name]: value } } });
    }

    async onSubmit() {
        this.setState({ error: false, submitAttempted: true });
        const signature = this.state.signature;
        if (!signature.fundId || !signature.file) return;
        await this.props.addSignature(signature);

        if (this.props.success) {
            this.onClose();
            this.props.reloadPaymentSettings();
        }
         else this.setState({ error: true });
    }

    onClose() {
        this.setState({signature: {
            fundId: '',
            file: null
        },
        error: false,
        submitAttempted: false,
        rejectedFile: false});
        this.props.close();
    }


    onFileDrop(files) {
        //to avoid memory leaks
        const file = files[0];
        window.URL.revokeObjectURL(file.preview)
        this.onChange('file', file);
    }

    dropRejected(rejectedFile) {
        this.setState({ rejectedFile: true }, () => {
            setTimeout(() => {
                if (this.refs.dropzone) {
                    this.setState({ rejectedFile: false })
                }
            }, 5000);
        });
    }


    render() {
        let {signature} = this.state;
        return (
            <Modal modalShowing={this.props.show}>
                <div className="modal-container">
                    <div className="modal new-signature-modal large-modal">
                        <div className="modal-header">
                            <h4 className="page-header">{this.props.fundId ? `Upload new signature for ${this.props.fundName}` : 'Add New Signature'}</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose}></i>
                        </div>
                        <div className="modal-section">
                            {!this.props.fundId && !this.props.fundName && <div className="modal-row modal-row-full-width">
                                <ValidatedInput input={<Select clearable={true} options={this.props.funds} />}
                                    label="Fund" name="fundId" value={signature.fundId} onChange={this.onChange}
                                    required={true} showRequiredError={this.state.submitAttempted} />
                            </div>}
                            <div className="modal-row modal-row-full-width">
                                {signature.file ?
                                    <div>
                                        <i className="icon ion-document icon-left middle" />
                                        <label className="small-text">{signature.file.name}</label>
                                        <i className="icon ion-ios-close-outline trash-hover icon-right middle" onClick={this.onChange.bind(this, 'file', null)} />
                                    </div>
                                    :
                                    <div>
                                        <Dropzone ref="dropzone" className={`upload-box ${this.state.submitAttempted && !this.state.signature.file ? 'error' : ''}`} accept={'image/png,image/jpeg,image/jpg'} onDropRejected={this.dropRejected.bind(this)} disablePreview={true}
                                            onDropAccepted={this.onFileDrop.bind(this)} multiple={false} maxSize={4000000} >
                                            <p className="accent-text"><i className="icon ion-ios-cloud-upload-outline" />Drop files here or <br /> click to <span className="accent-text2 block">Upload Signature</span></p>
                                        </Dropzone>
                                        <FadeErrorMessage message="Incompatible file format or size, please make sure you are uploading an image up to 4MB" show={this.state.rejectedFile} timeOut={5000}/>
                                    </div>}
                            </div>
                        </div>
                        {this.props.loading ? <LoadingSpinner height="20" alignRight={true} /> :
                            <div className="modal-btns text-right">
                                <button className="btn btn-accent" onClick={this.onClose}>Cancel</button>
                                <button className="btn btn-primary" onClick={this.onSubmit}>Save</button>
                                <FadeErrorMessage show={this.state.error}/>
                            </div>}
                    </div>
                </div>
            </Modal>
        );
    }
}

//save, update, funds


// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/paymentSettings/SignatureModal.jsx